import HTTP from '../http'
const BASE_URL = '/tsg-author'
// const imgUrl = location.host.indexOf("dev.") != -1 || location.host.indexOf("test") != -1|| location.host.indexOf(":80") != -1 ? 'https://fdfs.cnknowledge.com/' : "https://kpp.cnknowledge.com/"
const imgUrl=process.env.VUE_APP_API_IMG_URL;
const url = "https://web.tonghangpingyi.com/txpy-web"
export default {
  imgUrl,
  url,
  //获取责任采编id
  queryEditingByUserId(data) {
    return HTTP.get(BASE_URL + '/web/submit/queryEditingByUserId', data)
  },
  //获取采编详细信息
  getEditingInfo(data) {
    return HTTP.get(BASE_URL + '/web/myArticle/getEditingInfo', data)
  },
  //获取版权协议
  querycopyrightAgreement(data) {
    return HTTP.get(BASE_URL + '/web/submit/querycopyrightAgreement', data)
  },
  //根据文章id获取文章信息
  queryArticleInfoById(data) {
    return HTTP.get(BASE_URL + '/web/submit/queryArticleInfoById', data)
  },
  findAuthorByPhoneAndName(data) {
    return HTTP.post(BASE_URL + '/web/submit/findAuthorByPhoneAndName', data)
  },
  findProvinceList(data) {
    return HTTP.get(BASE_URL + '/web/common/findProvinceList', data)
  },
  findAreaList(data) {
    return HTTP.get(BASE_URL + '/web/common/findAreaList', data)
  },
  registerAuthor(data) {
    return HTTP.json(BASE_URL + '/web/submit/registerAuthor', data)
  },
  findAuthorByAuthorId(data) {
    return HTTP.post(BASE_URL + '/web/submit/findAuthorByAuthorId', data)
  },
  saveArticle(data,ff) {
    return HTTP.json(BASE_URL + '/web/submit/saveArticle', data,false)
  },
  saveArticleForDraft(data) {
    return HTTP.json(BASE_URL + '/web/submit/saveArticleForDraft', data)
  },
  periodicalsInfo(data) {
    return HTTP.get(BASE_URL + '/web/per/get', data)
  },
  submitArticle(data) {
    return HTTP.post(BASE_URL + '/web/submit/submitArticle', data)
  },
  getQrCode(data) {
    return HTTP.get(BASE_URL + '/web/order/getQrCode', data)
  },
  //稿件下载
  manuscript(data) {
    return HTTP.get(BASE_URL + '/web/download/downloadArticlePDF', data)
  },
  billQuery(data,ff){
    return HTTP.get( BASE_URL + '/web/order/billQuery',data,false)
  }

}